<lib-header data-test-id="synlab-header-lib-header"
  [links]="(links$ | async) ?? []"
  [user]="(user$ | async) || undefined"
  [disableLinks]="disableLinks"
  (onLogout)="logout()"
  [myAccountLink]="myAccountLink$|async"
  [brandLogoLink]="brandLogoLink$|async">
</lib-header>

